import { render, staticRenderFns } from "./tongJiaShiYi.vue?vue&type=template&id=23060b6e&scoped=true&"
import script from "./tongJiaShiYi.vue?vue&type=script&lang=js&"
export * from "./tongJiaShiYi.vue?vue&type=script&lang=js&"
import style0 from "./tongJiaShiYi.vue?vue&type=style&index=0&id=23060b6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23060b6e",
  null
  
)

export default component.exports